import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "umi";
import Loading from "../Loadings";

interface MetricInfoProps {
  data: any;
  children: React.ReactNode;
  [key: string]: any;
}
interface IMetricInfoItem {
  // 指标英文名称
  en: string;
  // 指标中文名称
  cn: string;
  // 指标英文提示
  tooltipEn: string;
  // 指标中文提示
  tooltipCn: string;
  // 指标格式化
  formatter: string;
}

const MetricInfo = (props: MetricInfoProps) => {
  const {data: propsData, children, ...restProps } = props;
  const { metricsInfo, metricsInfoReady } = useSelector((state: {
    dashboard?: {
      metricsInfo: IMetricInfoItem;
      metricsInfoReady: boolean;
    };
  }) => ({
    metricsInfo: state.dashboard?.metricsInfo,
    metricsInfoReady: state.dashboard?.metricsInfoReady,
  }), shallowEqual);

  const data = useMemo(() => ({
    ...(propsData || {}),
    metricsInfo
  }), [propsData, metricsInfo]);

  // 等待 metricsInfo 加载完成（成功或失败）后再渲染子组件
  if (!metricsInfoReady) {
    return <Loading style={{ height: '50vh' }} />;
  }

  return (
    React.Children.map(children, (child: any) =>
      React.cloneElement(child, {
        ...(restProps || {}),
        data,
      }),
    )
  );
};

export default MetricInfo;